import React, { Suspense } from 'react'
import SkeletonPage from '@/components/skeleton'

function LazyElement(props: { importFunc: () => Promise<any> }) {
  const { importFunc } = props
  const LazyComponent = React.lazy(importFunc)
  return (
    <Suspense fallback={<SkeletonPage />}>
      <LazyComponent />
    </Suspense>
  )
}

export default LazyElement
